module.exports = __webpack_public_path__ + "media/MRI12-ad.15bf8ba3.mp3";